webpackJsonp([263791100135453],{

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SEO = __webpack_require__(21);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _pageModule = __webpack_require__(35);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        "div",
	        { className: _pageModule2.default.container },
	        _react2.default.createElement(_SEO2.default, { title: "About | A-Town FM" }),
	        _react2.default.createElement(
	            "h1",
	            null,
	            "About"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "From the land of Arnold, Missouri where the only skyscraper we need is a water tower, comes an entertainment podcast where two bold Midwesterners record a stream of consciousness touching on everything from movies, marketing, to technology. Be enlightened!"
	        ),
	        _react2.default.createElement(
	            "h3",
	            null,
	            "Official Accounts"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Reddit: ",
	            _react2.default.createElement(
	                "a",
	                { href: "https://www.reddit.com/r/atownfm/" },
	                "/r/atownfm"
	            )
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Facebook: ",
	            _react2.default.createElement(
	                "a",
	                { href: "https://www.facebook.com/atownfm/" },
	                "https://www.facebook.com/atownfm/"
	            )
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Twitter: ",
	            _react2.default.createElement(
	                "a",
	                { href: "https://twitter.com/atownfm" },
	                "@atownfm"
	            )
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Mastodon: ",
	            _react2.default.createElement(
	                "a",
	                { href: "https://mastodon.social/@atownfm" },
	                "@atownfm@mastodon.social"
	            )
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Email: ",
	            _react2.default.createElement(
	                "a",
	                { href: "mailto:atownfm@gmail.com" },
	                "atownfm@gmail.com"
	            )
	        ),
	        _react2.default.createElement(
	            "h3",
	            null,
	            "Charlie"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Twitter: ",
	            _react2.default.createElement(
	                "a",
	                { href: "https://twitter.com/chuckyc17" },
	                "@chuckyc17"
	            )
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Mastodon: ",
	            _react2.default.createElement(
	                "a",
	                { href: "https://mastodon.social/@charliemchapman" },
	                "@charliemchapman@mastodon.social"
	            )
	        ),
	        _react2.default.createElement(
	            "h3",
	            null,
	            "Dan"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Twitter: ",
	            _react2.default.createElement(
	                "a",
	                { href: "https://twitter.com/danlitz" },
	                "@DanLitz"
	            )
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Mastodon: still hasn't signed up... \uD83D\uDE12"
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-3aa2b14bd500a7f852ea.js